<template>
	<label
		class="ms-input flex ms-editor"
		:class="{
			isValid: errorProvider.isValid,
			'input-disabled': disabled,
			'pr-0': subtext,
			'non-border': !showBorder,
		}"
		v-tooltip="inputTooltip"
	>
		<div
			:class="['icon-input', 'mr-2', iconSize, classIconLeft]"
			v-if="iconLeft"
		></div>
		<input
			class="ms-input-item"
			:placeholder="placeholder"
			v-model="internalText"
			:disabled="disabled"
			:readonly="readOnly"
			:maxlength="maxLength"
			v-bind="$attrs"
			ref="input"
			:class="[
				{
					'input-disabled': disabled,
					'accept-input': isAcceptInfo,
				},
				classInput,
			]"
			v-on="listeners"
			:type="type"
		/>
		<div
			class="icon-input"
			v-tooltip="{
				content: errorProvider.message,
				show: focused,
				classes: `error`,
				autoHide: false,
				placement: 'bottom-end',
			}"
			v-if="errorProvider.isValid && showIconValid"
			@click="clickIcon"
		>
			<div class="mi mi-24 mi-red-tick"></div>
		</div>
		<div
			:class="['icon-input', 'mi-new-v2', iconSize, icon]"
			v-if="icon"
			@click="handleClickIcon"
		></div>
		<div
			v-if="hasIconClearText && hasInternalText"
			:class="[
				'item-icon',
				'mi-new-v2',
				'mi-16',
				iconClear || 'mi-icon-v2-delete-16 mr-2',
				'cursor-pointer',
			]"
			@click.stop="clearText"
		></div>
		<div v-if="subtext" class="subtext">{{ subtext }}</div>
	</label>
</template>
<script>
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
export default {
	extends: msBaseComponent,
	name: 'msInput',
	props: {
		/**
		 * V-model bắn ra ngoài binding 2 chiều
		 */
		value: {
			default: null,
		},
		/**
		 * Hiện thị chũ mờ ở dưới ô input
		 * Created by LTDAT(22.06.2020)
		 */
		placeholder: {
			default: null,
			type: [Number, String],
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		type: {
			default: null,
			type: String,
		},
		//class chứa icon
		icon: {
			default: null,
			type: String,
		},
		//input chỉ đọc không cho nhập
		readOnly: {
			default: false,
			type: Boolean,
		},
		//Giới hạn nhập của ô input
		maxLength: {
			default: null,
			type: Number,
		},
		subtext: {
			default: null,
			type: String,
		},
		iconLeft: {
			default: false,
			type: Boolean,
		},
		classIconLeft: {
			default: null,
			type: String,
		},
		//Mảng dữ liệu dùng để kiểm tra xem giá trị có tồn tại trong mảng hay không
		listData: {
			default: null,
			type: Array,
		},
		taxcodeOrgWorking: {
			default: null,
			type: String,
		},
		showBorder: {
			default: true,
			type: Boolean,
		},
		isAcceptInfo: {
			default: false,
			type: Boolean,
		},
		iconSize: {
			default: 'mi-16',
			typeof: String,
		},
		showIconValid: {
			default: true,
			type: Boolean,
		},
		classInput: {
			default: '',
			typeof: String,
		},
		//Hiện icon xóa nội dung đã nhập
		hasIconClearText: {
			default: false,
			type: Boolean,
		},
		//Class icon clear text, mặc định dùng icon delete
		iconClear: {
			default: null,
			type: String,
		},
	},
	data() {
		return {
			internalText: this.value,
			focused: false,
			displayValue: null,
			isLongText: false,
			isPlaceholderLong: false,
		};
	},
	updated() {
		const me = this;
		me.checkingLongText();
	},
	mounted() {
		const me = this;
		me.checkingLongText();
	},
	computed: {
		hasInternalText() {
			const me = this;
			return me.internalText != null && me.internalText != '' ? true : false;
		},
		inputTooltip() {
			const me = this;
			// Ưu tiên hiển thị tooltip của value nếu có value
			if (me.internalText && me.isLongText) {
				return me.internalText;
			}
			// Hiển thị tooltip của placeholder nếu input trống và placeholder dài
			if (!me.internalText && me.isPlaceholderLong) {
				return me.placeholder;
			}
			return null;
		},
		listeners() {
			return {
				blur: (e) => {
					this.onBlur(e);
				},
				focus: (e) => {
					this.onFocus(e);
				},
				change: (e) => {
					this.$emit('change', this.internalText, e);
				},
				input: (e) => {
					this.$emit('input', this.internalText);
				},
				keydown: (e) => {
					this.$emit('keydown', e);
				},
			};
		},
	},
	methods: {
		clickIcon(e) {
			const me = this;
			me.$emit('change', me.internalText, e);
		},
		getTextWidth(text) {
			const me = this;
			if (!text || !me.$refs.input) return 0;

			// Tạo 1 thẻ canvas trên dom
			const canvas = document.createElement('canvas');
			// Lấy text của nó
			const context = canvas.getContext('2d');
			// Thiết lập thuộc tính font giống với input
			const computedStyle = window.getComputedStyle(me.$refs.input);
			context.font = computedStyle.font;

			// Đo chiều rộng của text theo pixel thực tế.
			return context.measureText(text).width;
		},
		checkingLongText() {
			const me = this;
			if (me.$refs.input) {
				// Check input value
				if (me.$el.offsetWidth < me.$refs.input.scrollWidth) {
					me.isLongText = true;
				} else {
					me.isLongText = false;
				}

				// Check placeholder
				if (me.placeholder && !me.internalText) {
					const placeholderWidth = me.getTextWidth(me.placeholder);
					const inputPadding =
						parseFloat(window.getComputedStyle(me.$refs.input).paddingLeft) +
						parseFloat(window.getComputedStyle(me.$refs.input).paddingRight);
					const availableWidth = me.$refs.input.offsetWidth - inputPadding;

					if (availableWidth < placeholderWidth) {
						me.isPlaceholderLong = true;
					} else {
						me.isPlaceholderLong = false;
					}
				} else {
					me.isPlaceholderLong = false;
				}
			}
		},
		//Sự kiện focus vào ô input
		onFocus(e) {
			const me = this;
			me.focused = true;
			me.$emit('focus', e);
		},
		//Sự kiên blur ra ngoài ô input
		onBlur(e) {
			const me = this;
			me.focused = false;
			me.$emit('blur', e);
		},
		//Reset lại giá trị về ban đầu
		reset() {
			const me = this;
			me.internalText = null;
			me.displayValue = null;
		},
		//Set giá trị cho ô input
		setValue(value) {
			const me = this;
			me.internalText = value;
		},
		handleClickIcon() {
			this.$emit('clickIcon');
		},
		clearText() {
			const me = this;
			if (!me.hasIconClearText) return;
			me.internalText = '';
			me.$emit('change', '');
			me.$refs.input.focus();
		},
	},
	watch: {
		internalText: {
			handler(newVal, oldVal) {
				const me = this;
				me.$emit('input', newVal);
				me.$nextTick(() => {
					if (!me.listData && !me.taxcodeOrgWorking) this.validate();
					else {
						if (me.listData) this.validate(me.value, me.listData);
						else if (me.taxcodeOrgWorking)
							this.validate(me.value, me.taxcodeOrgWorking);
					}
					// Re-check placeholder khi value thay đổi
					me.checkingLongText();
				});
			},
		},
		placeholder: {
			handler(newVal, oldVal) {
				const me = this;
				me.$nextTick(() => {
					me.checkingLongText();
				});
			},
		},
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.setValue(newVal);
			},
		},
		disabled: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.validate();
				}
			},
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msInput.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msInput.scss';
}
::-webkit-input-placeholder {
	font-style: italic;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
:-moz-placeholder {
	font-style: italic;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
::-moz-placeholder {
	font-style: italic;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
:-ms-input-placeholder {
	font-style: italic;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
.ms-input-item::placeholder {
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
</style>
